import {
  ISelectedFilter,
  ISelectedFilterGroup,
  ISelectedFilterMap
} from "../../../../context/selectedFilters";

const sortEntityFilterByLevel = (
  { entityFilter: { level: levelA } }: ISelectedFilter,
  { entityFilter: { level: levelB } }: ISelectedFilter
): number => levelA - levelB;

const sortSelectedGroupByLevels = (selectedFilterGroup: ISelectedFilterGroup): ISelectedFilter[] =>
  Object.keys(selectedFilterGroup)
    .map(key => selectedFilterGroup[key])
    .sort(sortEntityFilterByLevel);

const selectedFilterToPath = (conector: string) => ({
  entityFilter,
  filter
}: ISelectedFilter): string => `${entityFilter.entity.slug}${conector}${filter.slug}`;

export const getFeaturedUrlPath = (filters: ISelectedFilterGroup) =>
  sortSelectedGroupByLevels(filters)
    .map(selectedFilterToPath("-"))
    .join("/");

export const getSecondaryUrlPath = (filters: ISelectedFilterGroup) =>
  sortSelectedGroupByLevels(filters)
    .map(selectedFilterToPath("="))
    .join("&");

export const buildUrl = (primaryFilters: string, secondaryFilters: string): string => {
  const primaryParams = primaryFilters.length > 0 ? `/${primaryFilters}` : "";
  const secondaryParams = secondaryFilters.length > 0 ? `?${secondaryFilters}` : "";
  return `${primaryParams}${secondaryParams}`;
};

export const buildUrlFromSelectedFilters = (selectedFilterMap: ISelectedFilterMap) => {
  const featured = getFeaturedUrlPath(selectedFilterMap.featured);
  const secondary = getSecondaryUrlPath(selectedFilterMap.secondary);
  return buildUrl(featured, secondary);
};
